import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/operator/delay';
import 'rxjs/operator/mergeMap';
import 'rxjs/operator/switchMap';
import 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class UserSessionObject {

    public username: string = '';
    public id_token: string = '';
    public UserAuthResponse: string = '';
    public selectedCategoryId: string = '';
    public isSSO: boolean = false;
    public Admin: string = 'false';
    public AdminCategoryId: string = '';
    public OrganizationGUID: string = '';
    public UserGUID: string = '';
    public UserRole: string = '';
    public SelectedUserRole: string = '';
    public LoginName: string = '';
    public scrHeight: number = 613;
    public scrWidth: number;
    public LabOrgGuids: string[];
    public ZohoCriteria: string = '';
    public ApplicationType: string = '';
    public ZohoClientRequestJSON: string;

    remotePosts = new BehaviorSubject([]);
    _router;

    constructor(public http: HttpClient, router: Router) {
        this._router = router;
    }

}